let widgetModules = null

function loadWidgetModules() {
  widgetModules ??= import('altcha')
    .then(() => import('altcha/i18n/de'))
    .catch((error) => {
      widgetModules = null
      throw error
    })

  return widgetModules
}

export default (messages, action) => {
  let wireId = null

  return {
    state: 'unverified',
    payload: null,
    submitting: false,

    init() {
      const root = this.$root?.closest?.('[wire\\:id]')
      wireId = root?.getAttribute('wire:id') || null
      this.retry()
    },

    get canRetry() {
      return this.state === 'error' || this.state === 'expired'
    },

    get canSubmit() {
      return !this.submitting && this.state === 'verified' && !!this.payload
    },

    get message() {
      return messages[this.state] || messages.unverified
    },

    handleState(event) {
      const nextState = event.detail?.state || 'unverified'
      if (nextState === 'unverified' && this.canRetry) {
        // ALTCHA resets its expired/error popover on outside clicks, before our click handler runs.
        this.retry()
        return
      }

      this.state = nextState
      this.payload = this.state === 'verified' && typeof event.detail?.payload === 'string'
        ? event.detail.payload
        : null
    },

    async retry() {
      this.state = 'verifying'
      this.payload = null

      try {
        await loadWidgetModules()
        await window.customElements.whenDefined('altcha-widget')
        const widget = this.$refs.widget
        if (!widget) return
        widget.reset()
        await widget.verify()
      } catch {
        this.state = 'error'
      }
    },

    async submit() {
      if (this.submitting) return
      if (!this.payload) {
        if (this.state !== 'verifying') await this.retry()
        return
      }

      const wire = wireId && window.Livewire?.find(wireId)
      if (!wire) return

      this.submitting = true
      try {
        await wire[action](this.payload)
        // A proof is single-use even when later domain validation keeps this form open.
        if (this.$root?.isConnected) {
          await this.retry()
        }
      } finally {
        this.submitting = false
      }
    }
  }
}
